import { render, staticRenderFns } from "./inpatientInfo.vue?vue&type=template&id=237de10a&scoped=true"
import script from "./inpatientInfo.vue?vue&type=script&lang=js"
export * from "./inpatientInfo.vue?vue&type=script&lang=js"
import style0 from "./inpatientInfo.vue?vue&type=style&index=0&id=237de10a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237de10a",
  null
  
)

export default component.exports